import * as React from 'react';
import { DayPicker, getDefaultClassNames } from 'react-day-picker';
import "react-day-picker/style.css";

import { cn } from '@/lib/utils';

import ChevronRight from '@/assets/svgs/chevron-right.svg?react';
import ChevronLeft from '@/assets/svgs/chevron-left.svg?react';

export type CalendarProps = React.ComponentProps<typeof DayPicker>;

function Calendar({
  className,
  classNames,
  showOutsideDays = true,
  ...props
}: CalendarProps) {

  const defaultClassNames = getDefaultClassNames();

  return (
    <DayPicker
      captionLayout="dropdown"
      showOutsideDays={showOutsideDays}
      className={cn('p-3', className)}
      classNames={{
        month: 'space-y-2',
        caption_label: 'text-textMedium',
        nav: 'hidden',
        day: cn(
          'h-8 w-8 p-0 aria-selected:opacity-100'
        ),
        selected:
          'bg-primary text-primary-foreground rounded-full hover:bg-primary hover:text-primary-foreground focus:bg-primary focus:text-primary-foreground',
        today: '',
        outside:
          'day-outside text-muted-foreground opacity-50  aria-selected:bg-accent/50 aria-selected:text-muted-foreground aria-selected:opacity-30',
        disabled: 'text-muted-foreground opacity-50',
        range_middle:
          'aria-selected:bg-accent aria-selected:text-accent-foreground',
        hidden: 'invisible',
        chevron: `${defaultClassNames.chevron} !fill-black`,
        ...classNames,
      }}
      components={{
        PreviousMonthButton: () => <ChevronLeft />,
        NextMonthButton: () => <ChevronRight />,
      }}
      {...props}
    />
  );
}
Calendar.displayName = 'Calendar';

export { Calendar };
